import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SccClientDetailsIntake from './modules/scc/bookings/SccClientDetailsIntake';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {window.location.pathname === '/scc/client-details' ? <SccClientDetailsIntake /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
